'use client';

// import mock data
import { _offices } from 'src/data/offices';
import { useLocale } from 'src/locales/localization-provider';

import { BackToTopButton } from 'src/components/animate/back-to-top-button';
import { ScrollProgress, useScrollProgress } from 'src/components/animate/scroll-progress';

import { ContactInfo } from '../contact-info';
import { ContactBaner } from '../contact-baner';
import { ContactFormInfo } from '../contact-form-info';
import OfficialCompanyDetails from '../OfficialCompanyDetails';
import { ContactAssist } from '../contact-assist';
// ----------------------------------------------------------------------

export function ContactUsView() {
  const pageProgress = useScrollProgress();
  const { t } = useLocale();

  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />
      <BackToTopButton />
      <ContactAssist />
      {/* <ContactBaner /> */}
      {/* ✅ Passing mock data */}
      <ContactInfo />
      <OfficialCompanyDetails />

      <ContactFormInfo />
    </>
  );
}
